import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

import Button from './Button';

const StyledDrawer = styled(MuiDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    margin: 24,
    height: 'calc(100% - 48px)',
    borderRadius: 8,

    [theme.breakpoints.down('md')]: {
      margin: 24,
      height: 'calc(100% - 48px)',
    },

    [theme.breakpoints.down('sm')]: {
      margin: 8,
      height: 'calc(100% - 16px)',
      width: 'calc(100% - 16px)',
    },
  },

  '& .MuiBackdrop-root': {
    backdropFilter: 'blur(3px)',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
}));

const Drawer = ({ open, onClose, title, subtitle, cancelText = 'Cancel', onCancel, submitText = 'Submit', onSubmit, disabled, loading, children, hideSubmit }) => (
  <StyledDrawer
    anchor="right"
    open={open}
    onClose={onClose}
  >
    <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between' }}>
      <Box>
        <Typography sx={{ fontSize: 18, fontWeight: 600 }}>{title}</Typography>
        {!!subtitle && (
          <Typography sx={(theme) => ({ fontSize: 14, color: theme.palette.text.secondary })}>{subtitle}</Typography>
        )}
      </Box>
      <Box>
        <IconButton size='sm' onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
    <Divider />
    <Box sx={{ flex: 1, padding: '12px 16px', overflow: 'auto' }}>
      {children}
    </Box>
    <Divider />
    <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
      <Button type='secondary' text={cancelText} onClick={onCancel || onClose} />
      {!hideSubmit && (
        <Button
          text={submitText}
          onClick={onSubmit}
          disabled={disabled || loading}
          loading={loading}
          sx={{ ml: 2 }}
        />
      )}
    </Box>
  </StyledDrawer>
);

export default Drawer;
